import { useState } from "react";

interface CrudModalState {
  create: boolean;
  edit: boolean;
  delete: boolean;
}

export const useCrudModals = <T,>() => {
  const [modals, setModals] = useState<CrudModalState>({
    create: false,
    edit: false,
    delete: false,
  });

  const [selectedItem, setSelectedItem] = useState<T | null>(null);

  const openCreate = () => {
    setModals((prev) => ({ ...prev, create: true }));
    setSelectedItem(null);
  };

  const openEdit = (item: T) => {
    setSelectedItem(item);
    setModals((prev) => ({ ...prev, edit: true }));
  };

  const openDelete = (item: T) => {
    setSelectedItem(item);
    setModals((prev) => ({ ...prev, delete: true }));
  };

  const closeAll = () => {
    setModals({ create: false, edit: false, delete: false });
    setSelectedItem(null);
  };

  const closeCreate = () => {
    setModals((prev) => ({ ...prev, create: false }));
  };

  const closeEdit = () => {
    setModals((prev) => ({ ...prev, edit: false }));
    setSelectedItem(null);
  };

  const closeDelete = () => {
    setModals((prev) => ({ ...prev, delete: false }));
    setSelectedItem(null);
  };

  return {
    modals,
    selectedItem,
    openCreate,
    openEdit,
    openDelete,
    closeAll,
    closeCreate,
    closeEdit,
    closeDelete,
  };
};
